/**
 * @generated SignedSource<<34223a3c982fc6ff80c9d9ba107e6665>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpRespSharedSellerDetails_item$data = {
  readonly dealerDetailsDisplayInfo: {
    readonly ctas: {
      readonly showMakeOffer: boolean | null;
    } | null;
  } | null;
  readonly seller: {
    readonly isAccessible: boolean | null;
    readonly isRewardsTier2: boolean | null;
    readonly liveStorefrontProfile: {
      readonly aboutUsUnbranded: string | null;
    } | null;
    readonly " $fragmentSpreads": FragmentRefs<"PdpSharedSellerDetailsBio_seller" | "PdpSharedSellerDetailsHeader_seller" | "PdpSharedSellerDetailsReviewContainer_seller" | "PdpSharedSellerDistinction_seller" | "PdpSharedSellerInfo_seller">;
  } | null;
  readonly " $fragmentSpreads": FragmentRefs<"ContactDealerInlineForm_item" | "PdpSharedCallDealerCta_item" | "PdpSharedSellerTabs_item">;
  readonly " $fragmentType": "PdpRespSharedSellerDetails_item";
};
export type PdpRespSharedSellerDetails_item$key = {
  readonly " $data"?: PdpRespSharedSellerDetails_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespSharedSellerDetails_item">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "afterDisplay"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespSharedSellerDetails_item",
  "selections": [
    {
      "alias": "dealerDetailsDisplayInfo",
      "args": null,
      "concreteType": "ItemDisplayInfo",
      "kind": "LinkedField",
      "name": "displayInfo",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "CTADisplay",
          "kind": "LinkedField",
          "name": "ctas",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "showMakeOffer",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Seller",
      "kind": "LinkedField",
      "name": "seller",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isAccessible",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "StorefrontProfile",
          "kind": "LinkedField",
          "name": "liveStorefrontProfile",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "aboutUsUnbranded",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": "isRewardsTier2",
          "args": [
            {
              "kind": "Literal",
              "name": "listName",
              "value": "SELLER_REWARDS_2"
            }
          ],
          "kind": "ScalarField",
          "name": "isAnchorListMember",
          "storageKey": "isAnchorListMember(listName:\"SELLER_REWARDS_2\")"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "PdpSharedSellerInfo_seller"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "PdpSharedSellerDetailsBio_seller"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "PdpSharedSellerDistinction_seller"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "PdpSharedSellerDetailsHeader_seller"
        },
        {
          "condition": "afterDisplay",
          "kind": "Condition",
          "passingValue": true,
          "selections": [
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "PdpSharedSellerDetailsReviewContainer_seller"
            }
          ]
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedCallDealerCta_item"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ContactDealerInlineForm_item"
    },
    {
      "condition": "afterDisplay",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "PdpSharedSellerTabs_item"
        }
      ]
    }
  ],
  "type": "Item",
  "abstractKey": null
};

(node as any).hash = "877a254385b42b7ec3da768edda44b20";

export default node;
